import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

export const failPurchaseExecution = createAction<
  PurchaseErrorState["errorStatus"]
>("purchaseError/failPurchaseExecution");

export const closePurchaseErrorModal = createAction(
  "purchaseError/closeErrorModal"
);

export interface PurchaseErrorState {
  showPurchaseErrorModal: boolean;
  errorStatus?: number | string;
}

const initialState: PurchaseErrorState = {
  showPurchaseErrorModal: false,
};

const purchaseErrorSlice = createSlice({
  name: "purchaseError",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        failPurchaseExecution,
        (state, action: PayloadAction<PurchaseErrorState["errorStatus"]>) => ({
          ...state,
          showPurchaseErrorModal: true,
          errorStatus: action.payload,
        })
      )
      .addCase(closePurchaseErrorModal, (state) => ({
        ...state,
        showPurchaseErrorModal: false,
        errorStatus: undefined,
      }));
  },
});

export default purchaseErrorSlice;
